import { useMemo } from 'react';
import { createBrandUrl } from '@/utilites/search/create-search-urls';

type PopularBrandsConstants = {
  name: string;
  image: string;
  href: string;
};

export default function usePopularBrands() {
  const popularBrands: PopularBrandsConstants[] = useMemo(() => {
    return [
      {
        name: 'Yamazaki',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/10.webp',
        href: createBrandUrl('Yamazaki'),
      },
      {
        name: 'Ardbeg',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/2.webp',
        href: createBrandUrl('Ardbeg'),
      },
      {
        name: 'Johnnie Walker',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/7.webp',
        href: createBrandUrl('Johnnie Walker'),
      },
      {
        name: 'Laphroaig',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/3.webp',
        href: createBrandUrl('Laphroaig'),
      },
      {
        name: 'Lagavulin',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/4.webp',
        href: createBrandUrl('Lagavulin'),
      },
      {
        name: 'Macallan',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/1.webp',
        href: createBrandUrl('Macallan'),
      },
      {
        name: 'Glenfiddich',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/12.webp',
        href: createBrandUrl('Glenfiddich'),
      },
      {
        name: 'Bowmore',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/11.webp',
        href: createBrandUrl('Bowmore'),
      },
      {
        name: 'Dalmore',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/14.webp',
        href: createBrandUrl('Dalmore'),
      },
      {
        name: 'Hibiki',
        image: 'https://dataspiritory.b-cdn.net/static/popular_brands/18.webp',
        href: createBrandUrl('Hibiki'),
      },
    ];
  }, []);

  return popularBrands;
}